var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsheader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1969_8438",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1969_8438",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAABSlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9mcS2dAAAAbXRSTlMAAQIDBQYHCQoLDxAWFxgaGx0eHyAmJygpKisyMzQ1Njg5Ozw+P0FCQ0ZKS05QUVRVVltcYWJjZGZnaGlscHV4eXt+f4OFhoiLkpWXmJqdnqCmqq+ytbe5ur7AwcrMzs/R09XZ4ujv8fP3+fv9ayG1jwAAAYRJREFUGBmtwWtTjGEAgOH7fTZFp60NWyGLFCI5lCJJtpRDzofosBVatff//+rd551mdmfsF+O6+De5+TMwej/Qyo7VrnzNLVp5ZDRNoyRJOFbQmtpNg0n1BlH/+EcXkrDm+7F+ohzwWl0BcgRTATpMBVKl2hzsqlskD48Gg6kE2k0FoKR+3bdu/7s6XJzccJrkmZ9unQXCkc0OoKAHv7WHaNxml+CB0T0y66ae9J7sXTT1Ctj1MF/UHTIV9QJ1I2oFaFsZgZtP20jdeftTLZMpqzur12lgNEBmwIgGRp1kOo1oYDRA5rQRDcbKm+oymWX1x5spmlXUEnUldRs48fw8TC62kXlpail/Kr9kah3Y9bBvUCtEl212DaaN7hJVbXaUUNBfVe0hKqobe9btfVYvDk19c5ak7JfbQ9QN1+ZgS92Bmdq5YCqBdlOBuhywqr4AAsFUgA5TgWMT6gRR39UPLiS5Nd+N5vm7gtbUblqZN5qhlW2rXX01N2kl97gIV2YD/8Mfljab2zdbkIAAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsheader);
export default __webpack_public_path__ + "static/media/settingsheader.5a49d0e565b6be4d06613c33182fffc8.svg";
export { ForwardRef as ReactComponent };